const paths = {
  root: '/',
  teach: 'teach',
  about: 'about-us',
  spaces: 'spaces',
  signin: 'signin',
  signup: 'signup',
  teachSignin: 'teach/signin',
  teachSignup: 'teach/signup',

  onboardStudent: 'onboard/student',
  orderConfirmation: 'order/confirmation',
  emailConfirmation: 'email/confirmation',
  emailVerification: 'fb447eb1/verify',
  verifyEmail: 'email/verify',
  studentEnrolment: 'enrolment',
  checkout: 'checkout',
  dashboard: 'dashboard',
  products: 'nigeria-curriculum/maths',
  curriculum: 'curriculum/nigeria/2025-26',
  classes: 'curriculum/nigeria/2025-26/maths',
  lessons: 'curriculum/nigerian/2025-26/maths/lesson',
  privacyPolicy: 'privacy-policy',
  termsOfUse: 'terms-of-use',
};

export default paths;
